import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { displayAlert } from "../../redux/actions/notif";
import { Navigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import { Container, Row, Col, Card } from "react-bootstrap";
import {Formik, Form} from "formik";
import * as yup from 'yup';
import RegistrationForm from './RegistrationForm';
import styles from './RegistrationPage.module.css';
import backgroundImage from '../../icons/registration-background.svg';
import * as apiProductTags from '../../apis/productTags';
import * as apiSupplierOnboard from '../../apis/supplierOnboard';

const RegistrationPage = () => {
    const dispatch = useDispatch();
    const [categories, setCategories] = useState([]);
    const [registeredSupplierCode, setRegisteredSupplierCode] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isRegistrationSuccess, setIsRegistrationSuccess] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (registeredSupplierCode) {
                setIsRegistrationSuccess(true);
            }
            const categoryPromise = apiProductTags.getByPrefixWithProductSkuId("category1-");
            const [categoryResponse] = await Promise.all([
                categoryPromise,
            ]);
            setCategories(categoryResponse.data.data);
        }
        fetchData().catch(console.error);
    }, [registeredSupplierCode])

    const handleUploadKtp = async (values) => {
        try {
            const res = await apiSupplierOnboard.uploadKtp({data: {
                base64: values.ktpFile,
                ext: values.ktpFileType
            }});

            if (res.data) {
                return res.data.data.imageUrl;
            } else {
                return null;
            }
        } catch (e) {
            console.log(e.message);
            return null;
        }
    }

    const handleUploadPricelist = async (formData) => {
        try {
            const res = await apiSupplierOnboard.uploadPricelist({data: formData});

            if (res) {
                return res;
            }
        } catch (e) {
            console.log(e.message);
            return null;
        }
    }

    const onSubmitRegistration = async (values) => {
        setIsSubmitting(true);
        if (!values.ktpFile || (!values.pricelist1 && !values.pricelist2 && !values.pricelist3)) {
            alert("KTP dan setidaknya 1 pricelist harus terisi");
            setIsSubmitting(false);
            return;
        }

        let ktpImageUrl;
        if (values.ktpFile !== "") {
            ktpImageUrl = await handleUploadKtp(values);
        }

        const formData = new FormData();
        if (values.pricelist1 !== "") {
            formData.append('pricelist', values.pricelist1);
        }
        if (values.pricelist2 !== "") {
            formData.append('pricelist', values.pricelist2);
        }
        if (values.pricelist3 !== "") {
            formData.append('pricelist', values.pricelist3);
        }

        const pricelistUrls = await handleUploadPricelist(formData);

        if (ktpImageUrl && pricelistUrls.data.data) {
            let requestBody = {
                ...values,
                ktpImageUrl: ktpImageUrl,
                pricelistImageUrls: pricelistUrls.data.data
            }

            try {
                const res = await apiSupplierOnboard.register({data: requestBody});
                if (res.data) {
                    setRegisteredSupplierCode(res.data.data.registrationCode);
                } else {
                    console.log(res.message);
                }
            } catch (e) {
                console.log(e.message);
            }
        } else {
            console.log("Gagal upload dokumen");
        }
        setIsSubmitting(false);
        return;
    }

    const validationSchema = yup.object().shape({
        registrarName: yup.string()
            .required('Nama pendaftar harus terisi')
            .matches(/^[a-zA-Z\s\.]+$/g, 'Data invalid. Mohon disesuaikan dengan contoh.'),
        email: yup.string().email('Data invalid. Mohon disesuaikan dengan contoh.').required('Email harus terisi'),
        whatsapp: yup.string()
            .required('Nomor Whatsapp harus terisi')
            .matches(/^[\+]?[0-9]{9,15}$/i, 'Data invalid. Mohon disesuaikan dengan contoh.'),
        productTags: yup.array().min(1),
        businessType: yup.string().required('Jenis perusahaan harus terisi'),
        businessName: yup.string().required('Nama pemilik/perusahaan harus terisi'),
        province: yup.string().required('Provinsi harus terisi'),
        city: yup.string().required('Kota harus terisi'),
        district: yup.string().required('Kecamatan harus terisi'),
        zipcode: yup.string()
            .required('Kode pos harus terisi')
            .matches(/^([0-9])\d{4}$/g, 'Kode pos harus terdiri dari 5 angka.'),
        address: yup.string().required('Alamat harus terisi'),
        pricelist1: yup.mixed()
            .test(
                'oneOfRequired',
                'Salah satu dari Pricelist 1, Pricelist 2, atau Pricelist 3 harus terisi',
                (item, context) => {
                    return (context.parent.pricelist1 || context.parent.pricelist2 || context.parent.pricelist3)
                }
            ),
        pricelist2: yup.mixed()
            .test(
                'oneOfRequired',
                'Salah satu dari Pricelist 1, Pricelist 2, atau Pricelist 3 harus terisi',
                (item, context) => {
                    return (context.parent.pricelist1 || context.parent.pricelist2 || context.parent.pricelist3)
                }
            ),
        pricelist3: yup.mixed()
            .test(
                'oneOfRequired',
                'Salah satu dari Pricelist 1, Pricelist 2, atau Pricelist 3 harus terisi',
                (item, context) => {
                    return (context.parent.pricelist1 || context.parent.pricelist2 || context.parent.pricelist3)
                }
            )
    });
    

    if (isRegistrationSuccess) {
        return <Navigate to={'/register-success/' + registeredSupplierCode} replace={true} />
    } else {
        return <div className={styles.container}>
            <Header activeKey="/" />
            <img src={backgroundImage} className={styles.backgroundImage} />
            <div className={styles.pageBody}>
                <Card className={styles.formCard}>
                    <h3>Ayo Daftar Jadi Supplier Segari!</h3>
                    <Formik
                        validationSchema={validationSchema}
                        initialValues={{
                            registrarName: '',
                            email: '',
                            whatsapp: '',
                            productTags: [],
                            businessType: '',
                            businessName: '',
                            province: '',
                            city: '',
                            district: '',
                            zipcode: '',
                            address: '',
                            ktpFile: '',
                            pricelist1: '',
                            pricelist2: '',
                            pricelist3: ''
                        }}
                        onSubmit={onSubmitRegistration}
                    >
                        {(formikProps) => 
                            <RegistrationForm 
                                {...formikProps}
                                categories={categories}
                                isSubmitting={isSubmitting}
                            />
                        }
                    </Formik>
                </Card>
            </div>
        </div>
    }
}

export default RegistrationPage;